module.exports = __webpack_public_path__ + "media/images/bg-about-sp-9b8570f1cd9f58a45cb6cf3773ccb200.jpg";